@if (scrapRule$ | async; as scrapRule) {
  <div class="layout-col full">
    <div class="layout-col gap-md p-pane">
      <elder-pane-subtitle>{{ 'context.general' | translate }}</elder-pane-subtitle>
      <div class="flex layout-row">
        <mat-form-field class="flex">
          <mat-label>{{ 'context.description' | translate }}</mat-label>
          <input
            matInput
            name="description"
            required
            placeholder="{{ 'context.description' | translate }}"
            [(ngModel)]="scrapRule.description"
          />
        </mat-form-field>
        <mat-form-field class="flex">
          <mat-label>{{ 'scrap.factor-percent' | translate }}</mat-label>
          <input
            matInput
            name="factor"
            type="number"
            required
            placeholder="{{ 'scrap.factor-percent' | translate }}"
            [(ngModel)]="scrapRule.quantitySpec.factor"
          />
        </mat-form-field>
      </div>
      <elder-pane-subtitle>{{ 'skillSets.conditions.title' | translate }}</elder-pane-subtitle>
    </div>
    <app-configuration-browser class="flex" [(configurations)]="scrapRule.conditions">
    </app-configuration-browser>
  </div>
}
